import React, { useState, useEffect} from "react";
import t from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

const element = {
  name: "jobTitle",
  prefix: "pf-contact-",
  id: "pf-contact-job-title",
  label: "Job Title",
  colLabelClassName: "label",
  colFieldClassName: "field",
  colValidationClassName: "messaging",
};
const defaultMsgData = {
  errors: { [element.name]: {} },
};
const msgDataWithError = {
  errors: {
    [element.name]: {
      id: element.id,
      slug: element.name,
      msg: "Job Title is required",
      type: "error",
    },
  },
};
const colLayout = {
  1: { sm: 12, lg: 3 },
  2: { sm: 12, lg: 2 },
  3: { sm: 12, lg: 1 },
  4: { sm: 12, lg: 6 },
};

const JobTitle = ({ fieldMetadata, onEventCallback, enableExtraEmploymentInfo, hasAutoFilled }) => {
  const [jobTitle, setJobTitle] = useState(fieldMetadata.value);
  const handleChange = (e) => {
    const { value } = e.target;
    setJobTitle(value);
    onEventCallback(e, {
      value,
      status: !!value ? "" : "invalid",
      isValid: !!value,
    });
  };

  useEffect(() => {
    const fEvent = {
      target: {
        name: 'jobTitle',
      }
    };
    // For disabled inputs we should reset the state as empty
    if (!enableExtraEmploymentInfo) {
      setJobTitle("");
      onEventCallback(fEvent, {
        value: "",
        status: "",
        isValid: true,
      });
    } else {
      setJobTitle(fieldMetadata.value);
      onEventCallback(fEvent, {
        value: "",
        status: "invalid",
        isValid: false,
      });
    }
  }, [enableExtraEmploymentInfo, hasAutoFilled]);

  return (
    <Row className={element.prefix + element.name}>
      <Col className={element.colLabelClassName} width={colLayout[1]}>
        <label className="label-split" htmlFor={element.id}>
          <span className="text">{element.label}</span>
        </label>
      </Col>
      <Col className={element.colFieldClassName} width={colLayout[1]}>
        <input
          value={fieldMetadata.value}
          disabled={!enableExtraEmploymentInfo}
          type="text"
          id={element.id}
          name={element.name}
          className={fieldMetadata.status}
          onChange={handleChange}
        />
      </Col>
      <Col className={element.colValidationClassName} width={colLayout[4]}>
        <ValidationMsg
          filterFields={[element.name]}
          msgs={
            (jobTitle === "" && fieldMetadata.status === "") ||
            jobTitle !== ""
              ? defaultMsgData
              : msgDataWithError
          }
        />
      </Col>
    </Row>
  );
};

JobTitle.propTypes = {
  hasAutoFilled: t.bool.isRequired,
  enableExtraEmploymentInfo: t.bool.isRequired,
  fieldMetadata: t.object.isRequired,
  onEventCallback: t.func.isRequired,
};

export default JobTitle;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');